import React, { FC, useContext, useEffect } from 'react';
import Permissions from 'Components/SmartList/Permissions';
import UserDetailsContext from 'Context/userDetailsContext';
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery } from '@apollo/react-hooks';
import { toastMessage } from 'Containers/Toast/actions';
import { setNewListValue } from 'Containers/Filter/ListMembership/actions/listMembership.actions';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { updateListGql, listSharedValueGql } from './gqlQuery';

interface Props {
  closeModal?: () => void;
  id?: string;
}

const PermissionsContainer: FC<Props> = ({ closeModal, id }: Props) => {
  const Dispatch = useDispatch();
  const userDetails = useContext(UserDetailsContext);
  const [updateList, { loading, error, data: updatedData }] =
    useMutation(updateListGql);

  // Get the list shared value //
  const { data: listData } = useQuery(listSharedValueGql, {
    variables: {
      inst_id: userDetails.instId,
      account_id: userDetails.accountId,
      id,
    },
    fetchPolicy: 'cache-and-network',
  });

  // Save and update list //
  const onSaveHandler = (e: any) => {
    const shared = e === 'shared';
    updateList({
      variables: {
        inst_id: userDetails.instId,
        account_id: userDetails.accountId,
        id,
        shared,
      },
    });
    // Store the value of e to pass to the Permissions component
    setNewListValue(Dispatch, true);
  };

  // If successfully updated, show toast confirmation message //
  useEffect(() => {
    if (updatedData) {
      if (
        updatedData.listUpdate.code >= 200 &&
        updatedData.listUpdate.code <= 299
      ) {
        Dispatch(
          toastMessage({
            message: `${updatedData.listUpdate.data.name} successfully updated`,
            position: 'bottom',
          })
        );
        if (closeModal) closeModal();
      }
    }
  }, [updatedData]);

  if (listData) {
    return (
      <Permissions
        errorMessage={error ? error.message : null}
        disabled={loading || updatedData}
        closeModal={closeModal}
        onSave={onSaveHandler}
        defaultValue={listData.list.shared ? 'shared' : 'private'}
        list={[
          {
            text: 'Shared within your Institution',
            secondaryText: 'Only users from your institution can view',
            value: 'shared',
          },
          {
            text: 'Private',
            secondaryText: 'Only you can view and edit',
            value: 'private',
          },
        ]}
      />
    );
  }
  return null;
};
PermissionsContainer.defaultProps = {
  closeModal: () => {},
  id: '',
};
export default withErrorBoundary(PermissionsContainer);
